import { createContext, useContext, useEffect, useMemo } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => useContext(ThemeContext);

/**
 * Dark is the only theme. There is no switch and no system following, so the
 * attribute is written once and stays put.
 *
 * The choice is kept as an attribute rather than folded into the base tokens
 * because theme.css still carries the light palette: dropping it is a wider
 * design-system edit than turning the theme off, and the tokens are harmless
 * while nothing can select them.
 */
export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  const value = useMemo(() => ({ isDark: true }), []);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
